import { getSissiEncoreUrl } from '../../config/server';

function buildListUrl(params = {}) {
  const query = {
    skip: params.skip || 0,
    limit: params.limit || 50,
  };
  const name = params.name || params.filter;
  if (name) {
    query.name = name;
  }
  const urlSearchParams = new URLSearchParams(query);
  const url = new URL(`${getSissiEncoreUrl()}/contact-title`);
  url.search = urlSearchParams.toString();
  return url;
}

async function parseErrorMessage(response) {
  try {
    const body = await response.json();
    return body?.message || body?.error || response.statusText;
  } catch (_e) {
    return response.statusText;
  }
}

export async function getContactTitles(params = {}) {
  const url = buildListUrl(params);
  const res = await fetch(decodeURIComponent(url.toString()), {
    credentials: 'include',
    mode: 'cors',
  });
  if (res.status !== 200) {
    throw await res.json();
  }
  return await res.json();
}

export async function getContactTitle(id) {
  const url = new URL(`${getSissiEncoreUrl()}/contact-title/${id}`);
  const res = await fetch(decodeURIComponent(url.toString()), {
    credentials: 'include',
    mode: 'cors',
  });
  if (res.status !== 200) {
    throw await res.json();
  }
  return await res.json();
}

export async function saveContactTitle(data = {}) {
  if (!data.id) {
    return createContactTitle(data);
  }
  return updateContactTitle(data);
}

async function createContactTitle(data) {
  const url = `${getSissiEncoreUrl()}/contact-title`;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    mode: 'cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: data.name }),
  });
  if (response.status !== 201) {
    const message = await parseErrorMessage(response);
    throw new Error(`Error al guardar el título: ${message}`);
  }
  return response.json();
}

async function updateContactTitle(data) {
  const url = `${getSissiEncoreUrl()}/contact-title/${data.id}`;
  const response = await fetch(url, {
    method: 'PUT',
    credentials: 'include',
    mode: 'cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: data.name }),
  });
  if (response.status !== 200) {
    const message = await parseErrorMessage(response);
    throw new Error(`Error al actualizar el título: ${message}`);
  }
  return response.json();
}

export async function deleteContactTitle(data) {
  if (!data?.id) {
    return Promise.resolve(false);
  }
  const url = `${getSissiEncoreUrl()}/contact-title/${data.id}`;
  const response = await fetch(url, {
    method: 'DELETE',
    credentials: 'include',
    mode: 'cors',
  });
  if (response.status !== 200) {
    const message = await parseErrorMessage(response);
    throw new Error(`Error al eliminar el título: ${message}`);
  }
  return true;
}
